import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
    return {
        root: {
            "& hr": {
                width: `calc(100% + ${theme.spacing(8)})`,
                marginBottom: theme.spacing(2),
                marginLeft: theme.spacing(-4),
            }
        },
        chartContainer: {
            display: "flex",
            height: "260px",
            width: "100%",
            alignItems: "center"
        },
        tableHeaderCell: {
            "& th": {
                background: theme.palette.blue[2],
                fontWeight: "bold",
            }
        },
        dialogContent: {
            display: "flex",
            flexWrap: "wrap",
            gridGap: theme.spacing(2),
            marginBottom: theme.spacing(2)
        },
        footerView: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gridGap: theme.spacing(3),
            padding: theme.spacing(3, 5)
        },
        headerCell: {
            "& th": {
                background: theme.palette.primary.dark,
                color: theme.palette.primary.contrastText,
                fontWeight: "bold",
                "& span": {
                    color: "inherit",
                    "&:hover": {
                        color: "inherit"
                    }
                },
                "& .Mui-active": {
                    color: theme.palette.primary.contrastText,
                },
                "& .MuiTableSortLabel-icon": {
                    color: theme.palette.primary.contrastText,
                },
                "& svg": {
                    color: theme.palette.primary.contrastText,
                    "&:hover": {
                        color: "inherit"
                    }
                },
            }
        },
    };
});
